<template>
  <div class="flex flex-col items-center w-1/3 sm:w-2/5">
  <h1 class="resume-section-title w-screen sm:w-full p-6">{{ 'education-title' | lang('education') }}</h1>
    <div v-for="(item, index) in getEducationList()" :key="index"
      class="font-serif mb-4 4k:mb-8 resume-section-item rounded-full 
      dark:bg-summer-lilac dark:text-gray-900
      bg-summer-marine transform text-center self-center
      w-80 sm:w-max p-8 sm:p-6 4k:p-14 text-base sm:text-sm fhd:text-lg 4k:text-4xl"
      :class="{
        'sm:self-start -rotate-2': index === 0,
        'sm:self-end rotate-3 mt-2': index === 1,
        'sm:self-start -rotate-2 mb-6': index === 2,
        'sm:self-center rotate-1': index === 3,
      }">
      <ul>
        <li class="font-bold">{{ getTitle(item) }}</li>
        <li>{{ getPlace(item) }}</li>
        <li>{{ getLearned(item) }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listEducation: this.$options.filters.lang('education-list', 'education'),
    };
  },
  methods: {
    getEducationList() {
      return Object.keys(this.listEducation);
    },
    getTitle(item) {
      return this.listEducation[item].title;
    },
    getPlace(item) {
      return this.listEducation[item].place;
    },
    getLearned(item) {
      return this.listEducation[item].learned;
    }
  },
}
</script>
